<template>
<div class="">
<user-top></user-top>
<div class="millia">
<div class="blueBg">
<p><b>报名开始时间:</b>{{SysInfo.apply_start_time}}</p>
<p><b>报名结束时间:</b>{{SysInfo.apply_end_time}}</p>
<p><b>相关说明:</b>{{SysInfo.system_description}}</p>
</div>
<ul class="infoList">
<li data-method="notice" class="noticePost">招考简章</li>
<li v-show="isshow">
<div class="ht tc mt10">我申请的职位</div>
<div v-for="list in myApply" :key="list.id" class="myList">
<p><b>部门：</b>{{list.dept_name}}</p>
<p><b>职位：</b>{{list.position_title}}</p>
<p><b>时间：</b>{{list.create_time}}</p>
<p><b>状态：</b>{{list.status_text}}</p>
<p><b>成绩：</b><i>{{list.score}}</i></p>
<!--<p><a target="_blank" href="https://api.jiaodong.net/ytgdzk/public/downLoad/passCheck.pdf" class="layui-btn layui-btn-danger layui-btn-fluid">考试通行证下载</a></p>-->
<p v-if="list.refuse_reason != ''"><b>意见：</b>
<span v-for="items in list.refuse_reason" :key="items.id">{{items}}</span>
</p>
<p v-if="list.status ===2&& list.pdf_url != ''"><a target="_blank" :href="list.pdf_url" :download="list.pdf_url" class="layui-btn layui-btn-danger layui-btn-fluid">报名表下载</a></p>
<p v-if="list.status ===2&& list.ticket_url != ''"><a target="_blank" :href="list.ticket_url" :download="list.ticket_url" class="layui-btn layui-btn-danger layui-btn-fluid">准考证下载</a></p>
<p v-if="list.status !=2">
<router-link to="/SaveApply" tag="a" class="layui-btn layui-btn-fluid">修改报考岗位</router-link>
</p>
</div>
</li>
<li><router-link to="BasicInfo" tag="a">
<span class="layui-icon">&#xe66f;</span>
基本资料
</router-link></li>
<li><router-link to="EduExp" tag="a">
<span class="layui-icon">&#xe62a;</span>
教育经历
</router-link></li>
<li><router-link to="JobExp" tag="a">
<span class="layui-icon">&#xe637;</span>
工作经历
</router-link></li>
<li><router-link to="FamilyGroup" tag="a">
<span class="layui-icon">&#xe68e;</span>
家庭关系
</router-link></li>
<li><router-link to="SaveApply" tag="a">
<span class="layui-icon">&#xe615;</span>
申请职位
</router-link></li>
<li><router-link to="MyApply" tag="a">
<span class="layui-icon">&#xe600;</span>
我的申请
</router-link></li>
</ul>
</div>
<div id="postContent">
<h1>{{NoticeInfo.title}}</h1>
<div class="source">{{NoticeInfo.create_time}}</div>
<div class="content" v-html="NoticeInfo.content"></div>
</div>
</div>
</template>
<script>
import UserTop from '@/components/UserTop.vue'
export default {
    name: 'UserInfo',
    components: {
        UserTop
    },
    data (){
        return{
            NoticeInfo:{},//招考简章所有内容
            myApply:{},//我申请的职位
            isshow:false,//是否显示我申请的岗位信息
            SysInfo:"",//系统提示信息
        }
    },
    mounted(){
        this.getNoticeInfo();
        this.getSysInfo();
        //layui
        layui.use('layer', function(){
            var $ = layui.$;
            var layer = layui.layer;
            var active = {
                notice: function(){
                    //示范一个公告层
                    layer.open({
                        type: 1
                        ,title: ['招考简章', 'font-size:1.6rem;font-weight:bold;text-align:center;padding:.5rem 0 0 0;color:#1E9FFF;']
                        ,closeBtn: false
                        ,area: ['94%;','96%']
                        ,offset: ['2%', '3%']
                        ,shade: 0.8
                        ,id: 'LAY_layuipro' //设定一个id，防止重复弹出
                        ,btn: ['已阅']//['已阅', '关闭']
                        ,btnAlign: 'c'
                        ,moveType: 1 //拖拽模式，0或者1
                        ,content: $('#postContent')
                    });
                }

            }
            $('.noticePost').on('click', function(){
                var othis = $(this), method = othis.data('method');
                active[method] ? active[method].call(this, othis) : '';
            });
        });
    },
    methods:{
        //获取申请记录
        GetMyApply() {
            let url = "api/apply/getMyApply";
            let params = {}
            this.$ajax.get(url, params).then(function (response) {
                //console.log(response.data.data)
                if (response.data.status==1) {
                    this.myApply = response.data.data;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98){
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
        //获取招考简章
        getNoticeInfo(){
            let url = "api/notice/getNoticeInfo";
            let params = {}
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.NoticeInfo = response.data.data;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
        //获取系统提示信息
        getSysInfo(){
            let url = "api/sys/getSysInfo";
            let params = {}
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.SysInfo = response.data.data;
                    //console.log(this.SysInfo)
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
    },
    beforeMount(){
        this.GetMyApply();
    },
    watch:{
       myApply(newAllData,oldAllData){
            if (JSON.stringify(this.myApply) === '[]') {
                console.log("没有获取到用户已填信息");
            }else{
                console.log("获取到用户已填信息");
                this.isshow = true;
            }
       }
    }
}
</script>
<style scoped>
.blueBg{padding-bottom:1rem;font-size:1.4rem;color:#333;background:#0099CC;border-radius:1rem;padding:1.5rem;box-sizing:border-box;margin:3rem auto 2rem auto;color:#fff;font-size:1.4rem;line-height:3rem;}
.blueBg b{display:inline-block;margin-right:1rem;}
.infoList{font-size:0;}
.infoList li{display:inline-block;width:45%;margin:0 2% 2rem 2%;font-size:1.6rem;text-align:center;background:#D0EEFF;border:.1rem solid #99D3F5;border-radius:1rem;padding:1.5rem 0;}
.infoList li:nth-child(1),.infoList li:nth-child(2){width:94%;}
.infoList li span{display:block;font-size:4rem;margin-bottom:1rem;color:#0099CC;}
.infoList li a{display:block;}
.myList{font-size:1.4rem;color:#333;text-align:left;border:none;padding:0 2rem;}
/*.myList p{padding:1rem 0 0 4.5rem;position:relative;}*/
.myList p{display:flex;align-items:flex-start;padding:0.5rem 0;}
/*.myList p b{display:block;position:absolute;left:0;top:1rem;}*/
.myList p b{white-space:nowrap;}
.myList p span{display:block;padding-bottom:.8rem;font-size:1.4rem;color:#333;margin:0;}
.myList p span:last-child{padding:0;}
.myList p a{display:inline-block;}
.myList p i{font-style:normal;color:crimson;font-weight:bold;}
.myList p:last-child{padding-bottom:1rem;}
#postContent{display:none;padding:2rem 2rem 0 2rem;word-wrap:break-word;}
#postContent h1{font-size:1.7rem;text-align:center;font-weight:bold;padding:2rem 0;}
#postContent .source{font-size:1.3rem;text-align:center;color:#999;padding-bottom:1rem;border-bottom:.1rem dotted #d0d0d0;margin-bottom:2rem;}
#postContent p{padding-bottom:1rem;font-size:1.4rem;line-height:2.2rem;text-indent:2rem;}
#postContent p:last-child{padding-bottom:0;}
</style>